import { Container } from '@mantine/core';
import { useTank } from '@/contexts/TankContext';
import { NoTankSelected } from '@/components/common/NoTankSelected';
import { BulkImportWizard } from './BulkImportWizard';

export default function BulkImportPage() {
  const { selectedTank } = useTank();

  if (!selectedTank) {
    return (
      <Container size="lg" py="xl">
        <NoTankSelected purpose="to import livestock" />
      </Container>
    );
  }

  return <BulkImportWizard />;
}
